import React from 'react'
import './Index.css'
import AboutUs from './About'
import Social from '../../SocialNetworking/Index'

const About = (props) => {
    return (
        <div  className="container-fluid" ref = {props.refer}  >
            <div style = {{
                // background: "linear-gradient(268.71deg, #000000 -10.38%, #413939 101.21%)",
                background: 'linear-gradient(208.2deg, #61056C -24.98%, #323166 87.31%, #281858 109.28%)'
            /*backgroundColor : '#1F243A'*/ /*"paddingTop":"30px"*/}} className="row justify-content-center text-center" >
            <div>
                <AboutUs />
            </div>
            {/* <div className="col-auto" >
            <QuickLink onHomeClick = {props.onHomeClick} onServiceClick = {props.onServiceClick} 
                onContactClick = {props.onContactClick} onTestimonialClick = {props.onTestimonialClick} />
            </div>
            <div className="col-auto " >
            <Services />    
            </div> */}
            <Social />
            </div>

                
               
           
        </div>
    )
}

export default About
